var render, staticRenderFns
import script from "./VMixins.vue?vue&type=script&lang=js&"
export * from "./VMixins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b305a2')) {
      api.createRecord('66b305a2', component.options)
    } else {
      api.reload('66b305a2', component.options)
    }
    
  }
}
component.options.__file = "assets/js/scripts/VMixins/VMixins.vue"
export default component.exports